<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        waringTypeOptions: [],
        orgIdOptions: [],
        form: [
          { // 申请号码
            label: '申请号码',
            value: 'applyNum',
            type: 'input',
            placeholder: '请输入申请号码',
          },
          { // 申请时间
            label: '申请时间',
            value: 'dateTime',
            type: 'date',
            placeholder: '请输入申请时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 催票方
            label: '催票方',
            value: 'hurryUserName',
            type: 'input',
            placeholder: '请输入催票方',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 预警时间
      if (searchBoxData.dateTime && searchBoxData.dateTime.length > 0) {
        searchBoxData.dateTimeStart = this.formatDate(searchBoxData.dateTime[0]);
        searchBoxData.dateTimeEnd = this.formatDate(searchBoxData.dateTime[1]);
        delete searchBoxData.dateTime;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
